import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, FileText } from 'lucide-react';
import AdSlot from '../advertisement/AdSlot';
import { RELATED_REPORTS } from '../../data/gmpBoardData';

// Partner ad (GET /api/ads): GMP slot first, then the shared in-content one
export const DematAccountsCard = () => <AdSlot slotId={['ipo-gmp-sidebar', 'incontent']} variant="compact" />;

const REPORT_LINK_CLASS =
  'group flex items-center gap-2 py-2.5 text-xs font-semibold text-slate-600 hover:text-[#008080] transition-colors';

// reports: [{ label, href }]; site paths ("/sme-ipos") use client-side routing
export const RelatedReportsCard = ({ title = 'Related IPO Trackers', reports = RELATED_REPORTS }) => (
  <div className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
    <h3 className="text-sm font-extrabold text-slate-900 mb-2">{title}</h3>
    <ul className="divide-y divide-slate-100">
      {reports.map((report) => {
        const content = (
          <>
            <FileText className="w-3.5 h-3.5 text-slate-400 group-hover:text-[#008080] flex-shrink-0" />
            <span className="flex-1">{report.label}</span>
            <ChevronRight className="w-3.5 h-3.5 text-slate-300 group-hover:text-[#008080] group-hover:translate-x-0.5 transition-transform" />
          </>
        );
        return (
          <li key={report.label}>
            {report.href.startsWith('/') ? (
              <Link to={report.href} className={REPORT_LINK_CLASS}>
                {content}
              </Link>
            ) : (
              <a href={report.href} className={REPORT_LINK_CLASS}>
                {content}
              </a>
            )}
          </li>
        );
      })}
    </ul>
  </div>
);
